/** Narrow-and-throw helper used at domain boundaries. */
export function invariant(condition: unknown, message: string): asserts condition {
  if (!condition) throw new Error(`[stage-zero] invariant failed: ${message}`);
}

export function clamp(value: number, min: number, max: number): number {
  return value < min ? min : value > max ? max : value;
}

/** Linear gain <-> decibels. `-Infinity` dB maps to silence. */
export function dbToGain(db: number): number {
  return db <= -100 ? 0 : Math.pow(10, db / 20);
}

export function gainToDb(gain: number): number {
  return gain <= 0 ? -Infinity : 20 * Math.log10(gain);
}
